export default "__VITE_ASSET__c2983a78__"